export const normalizeSelection = (value) => {
  if (Array.isArray(value)) {
    return value.filter(Boolean);
  }

  if (value === 'All' || value === undefined || value === null || value === '') {
    return [];
  }

  return [value];
};

export const isAllSelection = (value) => normalizeSelection(value).length === 0;

export const matchesSelection = (candidate, selected) => {
  const normalized = normalizeSelection(selected);
  return normalized.length === 0 || normalized.includes(candidate);
};

export const sanitizeSelection = (selected, availableOptions = []) => {
  const available = new Set(availableOptions);
  return normalizeSelection(selected).filter((item) => available.has(item));
};
